export enum UserStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  VALIDATING = 'validating',
  VALIDATED = 'validated',
  REFUSED = 'refused',
}
